(function () {
    'use strict';

    angular
        .module('app')
        .controller('WinbackCampaignsListController', WinbackCampaignsListController);

    WinbackCampaignsListController.$inject = ['API', 'alert', 'debug', 'i18n',];

    function WinbackCampaignsListController(API, alert, debug, i18n) {
        var vm = this;
        vm.searchTerm = '';
        vm.page = 1;
        vm.perPage = 20;
        vm.search = search;
        vm.clearSearch = clearSearch;
        vm.listMeta = {};
        vm.loadingState = {
            winbackIsLoading: false
        };
        vm.openRemoveModal = openRemoveModal;
        vm.loadPage = loadPage;

        activate();

        function activate() {
            loadWinbackCampaigns();
        }

        function openRemoveModal(offer) {
            var promise = alert.confirm('remove-item');

            promise.then(function() {
                var removePromise = API.WinbackOffer.recycle({ id: offer.id }).$promise;

                removePromise.then(function() {
                    var index = vm.winbackCampaigns.findIndex(function(item) {
                        return item.id === offer.id;
                    });
                    vm.winbackCampaigns.splice(index, 1);
                    window.toast({ type: 'success', autoRemoveTime: 5000, message: i18n.get('OFFER_RECYCLED') });
                }, function() {});
            }, function() {});
        }

        function clearSearch() {
            vm.searchTerm = '';
            vm.page = 1;
            loadWinbackCampaigns();
        }

        function search() {
            vm.page = 1;
            loadWinbackCampaigns();
        }

        function loadPage(newPageNumber) {
            vm.page = newPageNumber;
            loadWinbackCampaigns();
        }

        function loadWinbackCampaigns() {
            var promise = null;
            if (vm.searchTerm && vm.searchTerm.length > 2) {
                promise = API.WinbackCampaign.search({
                    'q': vm.searchTerm,
                    'page': vm.page,
                    'per-page': vm.perPage,
                    'expand': 'winbackOffer',
                }).$promise;
            } else if (vm.searchTerm.length === 0) {
                promise = API.WinbackCampaign.get({
                    'page': vm.page,
                    'per-page': vm.perPage,
                    'expand': 'winbackOffer',
                }).$promise;
            }

            if (promise) {
                vm.loadingState.winbackIsLoading = true;
                promise.then(function (response) {
                    vm.winbackCampaigns = response.items;
                    vm.listMeta = response._meta;
                    vm.loadingState.winbackIsLoading = false;
                }, function (response) {
                    debug.log(response);
                });
            }
        }
    }
})();